'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _htmlToReact = require('html-to-react');

var _htmlToReact2 = _interopRequireDefault(_htmlToReact);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _heading = require('../../../atoms/heading');

var _heading2 = _interopRequireDefault(_heading);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var htmlToReactParser = new _htmlToReact2.default.Parser();

var renderImage = function renderImage(image) {
  if (image && image.src) {
    return _react2.default.createElement('a', {
      className: 'social-innovation-panel__image',
      href: image.href,
      'data-pa-click': 'Social-Innovation-panel-article',
      style: { backgroundImage: 'url(' + image.src + ')', backgroundSize: 'cover' }
    });
  }
  return null;
};

var renderHeadline = function renderHeadline(headline) {
  if (headline) {
    return _react2.default.createElement(
      _heading2.default,
      { level: '3', className: 'social-innovation-panel__headline pp-sans-small-regular h4' },
      htmlToReactParser.parse(headline.text)
    );
  }
  return null;
};

var renderParagraph = function renderParagraph(paragraph) {
  if (paragraph) {
    return _react2.default.createElement(
      'p',
      { className: 'social-innovation-panel__paragraph' },
      htmlToReactParser.parse(paragraph.text)
    );
  }
  return null;
};

var renderHatchText = function renderHatchText(hatchText) {
  if (hatchText && hatchText.text) {
    return _react2.default.createElement(
      'p',
      { className: 'social-innovation-panel__hatch-text' },
      htmlToReactParser.parse(hatchText.text)
    );
  }
  return null;
};

var SocialInnovationPanel = function SocialInnovationPanel(props) {
  var _props$content = props.content,
      image = _props$content.image,
      headline = _props$content.headline,
      paragraph = _props$content.paragraph,
      hatchText = _props$content.hatchText;


  var moleculeClasses = (0, _classnames2.default)('social-innovation-panel', props.className);

  return _react2.default.createElement(
    'div',
    { className: moleculeClasses },
    _react2.default.createElement(
      'div',
      { className: 'social-innovation-panel__top' },
      renderImage(image),
      renderHeadline(headline),
      renderParagraph(paragraph),
      renderHatchText(hatchText)
    )
  );
};

exports.default = SocialInnovationPanel;

// ESLint disabled because the PropTypes below are used, but
// they are processed before being used and ESLint does not detect that.

SocialInnovationPanel.propTypes = {
  /* eslint-disable react/no-unused-prop-types */
  config: _propTypes2.default.shape({
    squareImage: _propTypes2.default.bool
  }),
  content: _propTypes2.default.shape({
    image: _propTypes2.default.shape({
      src: _propTypes2.default.string.isRequired,
      alt: _propTypes2.default.string
    }),
    headline: _propTypes2.default.shape({
      text: _propTypes2.default.string.isRequired
    }),
    paragraph: _propTypes2.default.shape({
      text: _propTypes2.default.string.isRequired
    }).isRequired,
    hatchText: _propTypes2.default.shape({
      text: _propTypes2.default.string.isRequired
    })
  }),
  className: _propTypes2.default.string
  /* eslint-enable react/no-unused-prop-types */
};

SocialInnovationPanel.defaultProps = {
  config: {
    squareImage: false
  },
  content: {
    image: {
      src: 'https://www.paypalobjects.com/digitalassets/c/website/marketing/apac/ID/home/featuredoffer-ssense.png',
      alt: ''
    },
    headline: {
      text: '44 characters maximum'
    },
    paragraph: {
      text: '130 characters maximum for paragraph text which should ' + 'equal less than 4 lines of text, sentence case, normal punctuation.'
    },
    hatchText: {
      text: '44 characters maximum'
    }
  },
  className: ''
};


//////////////////
// WEBPACK FOOTER
// /donatenodeweb-ci-2793/workspace/donate-gro-release/~/marketing-components/dist/components/molecules/social-innovation-panel/jsx/SocialInnovationPanel.js
// module id = 566
// module chunks = 4